import { apiCall, apiCallAdmin } from "../../services/api-service";

export const getDefaultMilestoneApi = async (id) => {
  try {
    const response = await apiCall("GET", `getDefaultMilestone`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripsListApi = async (params) => {
  try {
    const response = await apiCall("GET", "trips", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitTripsAPI = async (body) => {
  try {
    const response = await apiCall("POST", "trips", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateTripsAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `trips/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripsEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `trips/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteTripsApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `trips/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteTripsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await apiCall("DELETE", "trips/bulkdelete", data);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripsViewApi = async (id) => {
  try {
    const response = await apiCall("GET", `trips/view/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `trips/workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `trips/est_workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getAllocationHistoryApi = async (id) => {
  try {
    const response = await apiCall("GET", `get_allocation_history/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleDetailApi = async (id) => {
  try {
    const response = await apiCall("GET", `vehicle/details/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getCustomerAutoCompleteApi = async (term) => {
  try {
    const response = await apiCall("GET", `customer/autosuggestion?term=${term}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getFromAddressAutoCompleteApi = async (term) => {
  try {
    const response = await apiCall("GET", `stops/from_address?term=${term}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getToAddressAutoCompleteApi = async (term) => {
  try {
    const response = await apiCall("GET", `stops/to_address?term=${term}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getStopsApi = async (body) => {
  try {
    const response = await apiCall("POST", `getstops`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getSortedStopsApi = async (body) => {
  try {
    const response = await apiCall("POST", `sort_stops`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsListApi = async (tripId) => {
  try {
    const response = await apiCall("GET", `trips/stops/${tripId}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getStopProductListApi = async (stopId) => {
  try {
    const response = await apiCall("GET", `stops/products/${stopId}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDriverAutoCompleteApi = async (employeeIdQueryParam, term) => {
  try {
    const response = await apiCallAdmin("GET", `get_driver?id=${employeeIdQueryParam}&term=${term}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateDriverAPI = async (body) => {
  try {
    const response = await apiCall("POST", `update_driver`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getNextMilestoneApi = async (id) => {
  try {
    const response = await apiCall("GET", `mobile/get_next_milestone/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getSkippedMilestoneApi = async (tripId, stopId) => {
  try {
    const response = await apiCall("GET", `trips/hold_status?trip_id=${tripId}&stop_id=${stopId}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getUpdateMilestoneApi = async (body) => {
  try {
    const response = await apiCall("POST", `mobile/trip/update_milestone`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getUpdateSkippedMilestoneApi = async (tripId, body) => {
  try {
    const response = await apiCall("POST", `trips/hold_status_update/${tripId}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};


export const getProductDetailsApi = async (stopId) => {
  try {
    const response = await apiCall("GET", `mobile/get_stop_products?stop_id=${stopId}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const productConfirmationApi = async (body) => {
  try {
    const response = await apiCall("POST", `mobile/update_product_confirmation`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const paymentUpdateApi = async (body) => {
  try {
    const response = await apiCall("POST", `mobile/update_payment`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const paymentUpdateImageApi = async (body) => {
  try {
    const response = await apiCall("PUT", `mobile/update_payment_image`, body);
    console.log("Payment image update response:", response);
    return response;
  } catch (err) {
    console.error("Error updating payment images:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const addTripHistoryAttachmentsApi = async (tripHistoryId, body) => {
  try {
    const response = await apiCall("POST", `mobile/trip_history/attachment/${tripHistoryId}`, body);
    console.log("Trip history attachments response:", response);
    return response;
  } catch (err) {
    console.error("Error adding trip history attachments:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Trip Template
export const downloadTripTemplateApi = async () => {
  try {
    const response = await apiCall("POST", `template_download`, { type: "trip" });
    return response;
  } catch (err) {
    console.error("Error downloading template:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object to prevent memory leaks
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
